import Modal from "react-awesome-modal";
import classes from "./sceDialogBox.scss";
import FocusTrap from "focus-trap-react";

class DialogBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      activeTrap: false
    };

    this.crossBtn = (<button style={{ outline: 0 }} className={[classes.crossButtonDialogBox, "fright"].join(" ")} aria-label='Close Dialog' onClick={this.onDialogCloseHandler.bind(this)} />);
    if (this.props.showCloseButton === "true") {
      this.crossBtn = (
        <button className={[classes.crossButtonDialogBox, "fright"].join(" ")} tabIndex="0" aria-label='Close Dialog' onClick={this.onDialogCloseHandler.bind(this)}><i className={"fas fa-times " + classes.timesIconColor} /><span className="sr-only">Valid field</span></button>
      );
    } else if (this.props.showCloseButton === "false") {
      this.crossBtn = (
        <button className={[classes.crossButtonDialogBox, "fright"].join(" ")} tabIndex="0" aria-label='Close Dialog' onClick={this.onDialogCloseHandler.bind(this)}><i className={"fas fa-times " + classes.timesDefaultIconColor} /><span className="sr-only">Valid field</span></button>
      );
    }
    this.closeModal = this.closeModal.bind(this);
  }

  onDialogCloseHandler() {
    if (this.props.isUserSessionExpired) {
      if (app.appService.isAuthenticated()) {
        this.closeModal();
      } else {
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.LOGOUT);
      }
    } else if (this.props.onDialogCloseHandler) {
      this.props.onDialogCloseHandler();
    } else {
      this.closeModal();
    }
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      if (!this.props.tncType) this.onDialogCloseHandler();
    }
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction.bind(this), false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  componentWillReceiveProps(nextProps) {
    this.configureModalAction(this.props, nextProps);
  }

  /**
   * to open/close modal based on props
   * @param {*} currentProps
   * @param {*} nextProps
   */
  configureModalAction = (currentProps, nextProps) => {
    if (currentProps.displayDialog !== nextProps.displayDialog) {
      if (nextProps.displayDialog) {
        this.openModal();
      } else {
        this.closeModal();
      }
    }
  }

  openModal() {
    app.logger.getLogger().info("open modal");
    this.setState({
      visible: true,
      activeTrap: true
    });
  }

  closeModal() {
    app.logger.getLogger().info("close modal");
    this.setState({
      visible: false,
      activeTrap: false
    });
  }

  onClickAwayHandler() {
    if (this.props.onClickAwayHandler) {
      this.props.onClickAwayHandler();
    } else {
      if (!this.props.tncType) {
        this.closeModal();
      }
    }
  }


  render() {
    let width = this.props.width || 'auto';
    return this.state.activeTrap ? (
      <FocusTrap>
        <section tabIndex='0' className={classes.sceDialogBoxSection}>
          <Modal
            visible={this.state.visible}
            width={width}
            height={this.props.height}
            effect="fadeInUp"
            onClickAway={this.onClickAwayHandler.bind(this)}
          >
            {this.props.children}
            {this.crossBtn}
          </Modal>
        </section>
      </FocusTrap>
    ) : (
        false
      );
  }
}

export default DialogBox;
